import { render, staticRenderFns } from "./integralPeopleItemStatistics.vue?vue&type=template&id=b9b21bb0&scoped=true&"
import script from "./integralPeopleItemStatistics.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemStatistics.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemStatistics.vue?vue&type=style&index=0&id=b9b21bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b21bb0",
  null
  
)

export default component.exports